import { PopoverPosition as BlueprintPopoverPosition } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import { OverflowMenuHorizontal } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';
import { OutlinedIconButton } from 'vet-bones/design-system/components';

import { stopPropagation } from 'src/utils/handlers/stopPropagation';

import styles from 'src/components/sidebarCard/sidebarCard.module.scss';

export type SidebarCardProps = {
  actions?: React.ReactNode;
  active?: boolean;
  children?: React.ReactNode;
  className?: string;
  condensed?: boolean;
  disabled?: boolean;
  divId?: string;
  menu?: React.ReactElement;
  menuTestId?: string;
  onClick?: () => void;
  selected?: boolean;
  testId?: string;
  title?: React.ReactNode;
};
export const SidebarCard: React.VFC<SidebarCardProps> = ({
  actions,
  active,
  children,
  className,
  condensed,
  disabled,
  divId,
  menu,
  menuTestId,
  onClick,
  selected,
  testId,
  title,
}) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  return (
    <div
      className={classNames(className, styles.sidebarCard, {
        [styles.sidebarCardActive]: active,
        [styles.sidebarCardCondensed]: condensed,
        [styles.sidebarCardDisabled]: disabled,
        [styles.sidebarCardSelected]: selected,
        [styles.sidebarCardInteractive]: !disabled && onClick,
      })}
      data-testid={testId}
      id={divId}
      onClick={disabled ? undefined : onClick}
      role="button"
      tabIndex={0}
    >
      <div className={styles.sidebarCardHeader}>
        <div className={styles.sidebarCardHeaderTitle}>{title}</div>
        {actions || menu ? (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div
            className={styles.sidebarCardHeaderActions}
            onClick={stopPropagation}
          >
            {actions}
            {menu ? (
              <Popover2
                className={classNames(styles.sidebarCardMenu, {
                  [styles.sidebarCardMenuOpen]: isMenuOpen,
                })}
                content={menu}
                isOpen={isMenuOpen}
                minimal
                onInteraction={setIsMenuOpen}
                popoverClassName={classNames(
                  'vb-menu-popover',
                  `vb-popover-position--${BlueprintPopoverPosition.BOTTOM_RIGHT}`
                )}
                position={BlueprintPopoverPosition.BOTTOM_RIGHT}
              >
                <OutlinedIconButton
                  elevated
                  leftIcon={OverflowMenuHorizontal}
                  testId={menuTestId}
                />
              </Popover2>
            ) : null}
          </div>
        ) : null}
      </div>
      {children}
    </div>
  );
};
